module.exports = __webpack_public_path__ + "img/50007.b39a127b.png";